import React, { useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
const featuredInsurances = [{
  name: 'Aetna',
  logo: 'https://cdn.magicpatterns.com/uploads/rJXtyaifWMW42RGc4m5KG6/aetna-removebg-preview.png'
}, {
  name: 'VSP',
  logo: 'https://cdn.magicpatterns.com/uploads/fKd6ioDQTFKuCP6K2djLjG/vsp-removebg-preview.png'
}, {
  name: 'NVA',
  logo: 'https://cdn.magicpatterns.com/uploads/kQrDegk5JahZDwfDnAMnX8/nva_logo.png'
}, {
  name: 'Davis Vision',
  logo: 'https://cdn.magicpatterns.com/uploads/bjKq1mDaccPAGmy7ECar7W/davis_vision.png'
}, {
  name: 'EyeMed',
  logo: 'https://cdn.magicpatterns.com/uploads/8Dv3sgU1mnt2S4BKebUzGP/eyemed.png'
}];
const allInsurances = [
// Featured (with logos)
...featuredInsurances,
// Additional plans (with uploaded logos)
{
  name: 'United Healthcare',
  logo: 'https://cdn.magicpatterns.com/uploads/iVKGChQJ9VaB3mQcJgtPsC/Uhc.png'
}, {
  name: 'UHC March Vision Care',
  logo: 'https://cdn.magicpatterns.com/uploads/qCYxMCymXJ41Fx36WeaEx5/uhc_March.jpg'
}, {
  name: 'UHC Spectera',
  logo: 'https://cdn.magicpatterns.com/uploads/naF934HAr6e7e72VpZm1D6/uhc_spectera.png'
}, {
  name: 'TRICARE',
  logo: 'https://cdn.magicpatterns.com/uploads/489bqPrSmmhF8PzNjgp9r5/Tricare.webp'
}, {
  name: 'BlueCross BlueShield',
  logo: 'https://cdn.magicpatterns.com/uploads/wFCpcjUjYjqc7uGErzSR4Z/bcbs.webp'
},
// Additional plans
{
  name: 'Cigna',
  logo: 'https://cdn.magicpatterns.com/uploads/5SwrfbYRsKvC2PwL5MX6Yg/cigna.png'
}, {
  name: 'Humana',
  logo: 'https://cdn.magicpatterns.com/uploads/dNJCVKcRXJ3z41M41BHKHa/humana.png'
}, {
  name: 'Medicare',
  logo: 'https://cdn.magicpatterns.com/uploads/sFvvQftGgWydvtsneUtsan/medicare.png'
}, {
  name: 'Medicaid',
  logo: 'https://cdn.magicpatterns.com/uploads/8S9ff75TRQM6SQZikjD7GX/medicaid.webp'
}, {
  name: 'Anthem',
  logo: 'https://cdn.magicpatterns.com/uploads/wW8X6cxVrkB4c3fKwF63HZ/anthem-2.webp'
}, {
  name: 'Superior Vision',
  logo: 'https://cdn.magicpatterns.com/uploads/jXYLqwuaixW7zwBsbVXH5R/superior_vision.png'
}, {
  name: 'Avesis',
  logo: 'https://cdn.magicpatterns.com/uploads/uSu8TmpbhtUbfDWHS7oBXC/avesis.png'
}, {
  name: 'Maryland Physicians Care',
  logo: 'https://cdn.magicpatterns.com/uploads/qphBwRa39SNtUG7n2XcPtP/Maryland_Physicians_care.png'
}, {
  name: 'Wellpoint',
  logo: 'https://cdn.magicpatterns.com/uploads/mgkQC2TWv7eDso7CpWdZG7/Wellpoint.png'
}, {
  name: 'Amerigroup',
  logo: 'https://cdn.magicpatterns.com/uploads/aaYLZbBGimGaAnpnprqBm6/Amerigroup.png'
}, {
  name: 'MedStar Family Choice',
  logo: 'https://cdn.magicpatterns.com/uploads/sw2NN6n1ex5MBiZJvK7bn6/medstar.svg'
}];
export function InsuranceLogos() {
  const [showModal, setShowModal] = useState(false);
  return <>
      <section className="py-16 md:py-20 bg-white border-t border-gray-100" data-id="element-411">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-412">
          {/* Section Header */}
          <div className="text-center mb-12" data-id="element-413">
            <motion.span initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="inline-block text-brand-gold uppercase tracking-wider text-sm font-bold mb-3" data-id="element-414">
              Trusted by Your Insurance
            </motion.span>
            <motion.h2 initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-2xl md:text-3xl font-heading font-bold text-brand-dark mb-4" data-id="element-415">
              Insurance Plans We Accept
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="text-neutral-text/70 max-w-2xl mx-auto" data-id="element-416">
              We work with most major vision and health insurance providers to
              make quality eye care accessible.
            </motion.p>
          </div>

          {/* Logos Grid */}
          <div className="flex flex-wrap justify-center items-center gap-10 md:gap-14 lg:gap-20 mb-12" data-id="element-417">
            {featuredInsurances.map((insurance, index) => <motion.div key={insurance.name} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.08 + 0.3
          }} className="px-6 py-4 flex flex-col items-center justify-center gap-3 rounded-card group" data-id="element-418">
                <img src={insurance.logo} alt={`${insurance.name} logo`} className="h-12 md:h-16 w-auto object-contain opacity-70 group-hover:opacity-100 transition-opacity duration-300" loading="lazy" data-id="element-419" />
                <span className="text-xs font-heading font-semibold text-neutral-text/0 group-hover:text-neutral-text/60 transition-colors duration-300" data-id="element-420">
                  {insurance.name}
                </span>
              </motion.div>)}
          </div>

          {/* View All Button */}
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.8
        }} className="text-center" data-id="element-421">
            <button onClick={() => setShowModal(true)} className="bg-brand-dark hover:bg-brand-dark/90 text-white px-8 py-3.5 rounded-button font-heading font-semibold transition-colors shadow-sm focus-ring" data-id="element-422">
              View All Insurances We Accept
            </button>
          </motion.div>
        </div>
      </section>

      {/* Insurance Modal */}
      <AnimatePresence data-id="element-423">
        {showModal && <>
            {/* Backdrop */}
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setShowModal(false)} className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50" data-id="element-424" />

            {/* Modal */}
            <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-425">
              <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.95
          }} transition={{
            duration: 0.25
          }} className="w-full max-w-3xl max-h-[85vh] bg-white rounded-card shadow-2xl overflow-hidden flex flex-col" data-id="element-426">
                {/* Modal Header */}
                <div className="flex items-center justify-between p-6 md:p-8 border-b border-gray-100" data-id="element-427">
                  <div data-id="element-428">
                    <h3 className="text-2xl font-heading font-bold text-brand-dark" data-id="element-429">
                      Accepted Insurance Plans
                    </h3>
                    <p className="text-neutral-text/60 text-sm mt-1" data-id="element-430">
                      We accept the following vision and health insurance
                      providers.
                    </p>
                  </div>
                  <button onClick={() => setShowModal(false)} className="w-10 h-10 rounded-full bg-surface-muted flex items-center justify-center hover:bg-gray-200 transition-colors focus-ring flex-shrink-0" aria-label="Close modal" data-id="element-431">
                    <XIcon className="w-5 h-5 text-brand-dark" data-id="element-432" />
                  </button>
                </div>

                {/* Modal Body */}
                <div className="overflow-y-auto p-6 md:p-8" data-id="element-433">
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4" data-id="element-434">
                    {allInsurances.map(insurance => <div key={insurance.name} className="flex flex-col items-center justify-center p-4 rounded-lg border border-gray-100 bg-surface-muted/50 min-h-[100px]" data-id="element-435">
                        {insurance.logo ? <img src={insurance.logo} alt={`${insurance.name} logo`} className="h-10 md:h-12 w-auto object-contain mb-2" loading="lazy" data-id="element-436" /> : <div className="w-12 h-12 bg-brand-gold/10 rounded-full flex items-center justify-center mb-2" data-id="element-437">
                            <span className="text-brand-gold font-heading font-bold text-lg" data-id="element-438">
                              {insurance.name.charAt(0)}
                            </span>
                          </div>}
                        <span className="text-xs font-heading font-semibold text-neutral-text/70 text-center leading-tight" data-id="element-439">
                          {insurance.name}
                        </span>
                      </div>)}
                  </div>

                  <p className="text-center text-sm text-neutral-text/50 mt-8" data-id="element-440">
                    Don't see your plan listed? Give us a call — we may still
                    accept your insurance.
                  </p>
                </div>
              </motion.div>
            </div>
          </>}
      </AnimatePresence>
    </>;
}